import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPalmistry = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.6665 7.83342C17.6665 6.72884 18.562 5.83342 19.6665 5.83342C20.771 5.83342 21.6665 6.72884 21.6665 7.83342V15.5001M17.6665 7.83342V5.16675C17.6665 4.06217 16.771 3.16675 15.6665 3.16675C14.562 3.16675 13.6665 4.06217 13.6665 5.16675L13.6668 7.16675M17.6665 7.83342V14.1667M13.6668 7.16675C13.6664 6.06257 12.771 5.1676 11.6668 5.1676C10.5622 5.1676 9.66679 6.06303 9.66679 7.1676L9.66651 17.4499L7.50611 15.2827C6.5582 14.3319 4.9968 14.4186 4.15937 15.4687C3.5186 16.2722 3.50091 17.4087 4.11635 18.2319L8.91593 24.3629C9.83423 25.5359 10.3332 27.3439 10.3332 28.8337M13.6668 7.16675V12.8334M25.667 15.7591L25.6665 11.5001C25.6665 10.3955 24.771 9.50008 23.6665 9.50008C22.562 9.50008 21.6665 10.3955 21.6665 11.5001",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.7002 19.8999L26.0318 20.7961C26.4666 21.9712 26.684 22.5588 27.1127 22.9874C27.5413 23.416 28.1289 23.6334 29.3041 24.0683L30.2002 24.3999L29.3041 24.7315C28.1289 25.1664 27.5413 25.3838 27.1127 25.8124C26.684 26.241 26.4666 26.8286 26.0318 28.0037L25.7002 28.8999L25.3686 28.0037C24.9338 26.8286 24.7164 26.241 24.2877 25.8124C23.8591 25.3838 23.2715 25.1664 22.0963 24.7315L21.2002 24.3999L22.0963 24.0683C23.2715 23.6334 23.8591 23.416 24.2877 22.9874C24.7164 22.5588 24.9338 21.9712 25.3686 20.7961L25.7002 19.8999Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.5 8.19995V3.19995M1 5.69995H6",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPalmistry;
